<template>
  <div class="toast-container position-fixed top-0 end-0 p-3 z-4">
    <div
      v-for="toast in toasts"
      :key="toast.id"
      class="toast align-items-center border-0 show mb-2"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      :class="`text-bg-${toast.type}`"
    >
      <div class="d-flex">
        <div class="toast-body text-pre-line">
          {{ toast.text }}
        </div>
        <button
          type="button"
          class="btn-close btn-close-white me-2 m-auto"
          @click="removeToast(toast.id)"
        ></button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useToast } from '@/composable/globalToast';

const { toasts, removeToast } = useToast();
</script>
